import React from "react";
import { Box, Typography } from "@mui/material";
import EmptyStateImage from '../images/empty-logs.png';

export default () => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
  >
    <Box margin={'2rem'}>
      <img src={EmptyStateImage} style={{ width: 300, height: 300 }} alt="" />
    </Box>
    <Typography variant="h6" gutterBottom>
      No Logs
    </Typography>
    <Typography>
      Your proxy logs will appear here after you make a request.
    </Typography>
  </Box>
)
